import configPusher from 'helpers/configPusher'

export default async function(id) {
  window.pusher = await configPusher(id)
  window.pusherId = id
}



// WEBPACK FOOTER //
// ./src/helpers/setupPusherForExports.js